import { MenuItem, useDisclosure } from "@chakra-ui/react";
import { InvestorEditDrawer } from "features/investors/InvestorEditDrawer";
import { InvestorTabProps } from "features/investors/InvestorTabProps";
import { useInvestorRetrieveSuspense } from "gen/endpoints/investor/investor";
import { PermissionTypeEnum } from "gen/model/permissionTypeEnum";
import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useOutletContext } from "react-router-dom";
import { Restricted } from "shared/components/access/Restricted";
import {
  ContentBlock,
  ContentBlockActions,
  ContentBlockBody,
  ContentBlockGroup,
  ContentBlockHeader,
  ContentBlockMenu,
} from "shared/components/content/ContentBlock";
import Descriptions from "shared/components/descriptions/Descriptions";
import { PageTabBody } from "shared/components/layout/PageTabBody";

export const InvestorTabProfile: React.FC = () => {
  const { investorId } = useOutletContext<InvestorTabProps>();
  const { t } = useTranslation(["common", "investor"]);

  const { data: investor, refetch } = useInvestorRetrieveSuspense(investorId);

  const { isOpen, onOpen, onClose } = useDisclosure();

  const onCloseComplete = useCallback(async () => {
    onClose();
    await refetch();
  }, [onClose, refetch]);

  return (
    <PageTabBody data-private={true}>
      <ContentBlockGroup>
        <ContentBlock>
          <ContentBlockHeader>
            <ContentBlockActions>
              <Restricted permission={PermissionTypeEnum.config}>
                <ContentBlockMenu>
                  <MenuItem onClick={onOpen}>{t("common:edit")}</MenuItem>
                </ContentBlockMenu>
              </Restricted>
            </ContentBlockActions>
          </ContentBlockHeader>
          <ContentBlockBody variant="descriptions">
            <Descriptions>
              <Descriptions.Item label={t("investor:name")}>
                {investor.name}
              </Descriptions.Item>
              <Descriptions.Item label={t("investor:primaryContactEmail")}>
                {investor.primary_contact_email}
              </Descriptions.Item>
            </Descriptions>
          </ContentBlockBody>
        </ContentBlock>
      </ContentBlockGroup>
      {isOpen && (
        <InvestorEditDrawer
          investor={investor}
          onCloseComplete={onCloseComplete}
        />
      )}
    </PageTabBody>
  );
};
